import { t } from "adapters/i18n";
import type { ServiceConstructor } from "../services.types";

export function RainHistoryServiceMixin<TBase extends ServiceConstructor>(
  Base: TBase
) {
  return class RainHistoryService extends Base {
    readonly rainHistoryUrl = `${process.env.REACT_APP_ENDPOINT}chuva/api/v1/chuva/csv`;

    async getFarmRainHistoryCsv(
      farmId: number,
      retreatId: number
    ): Promise<string> {
      try {
        const params = this.montaURLParametros({
          IdFazenda: farmId,
          IdRetiro: retreatId,
        });
        const url = this.montaURL(this.rainHistoryUrl, params);
        const result = await this.get(url);

        if (result.data == null) {
          return "";
        }

        return result.data as string;
      } catch (_) {
        throw new Error(t("rain:get-history-error"));
      }
    }

    async updateFarmRainHistory(
      farmId: number,
      retreatId: number,
      file: File
    ): Promise<void> {
      try {
        const formData = new FormData();
        formData.append("CSV", file, file.name ?? "arquivo.csv");

        const params = this.montaURLParametros({
          IdFazenda: farmId,
          IdRetiro: retreatId,
        });
        const url = this.montaURL(this.rainHistoryUrl, params);

        await this.post(url, formData);
      } catch (_) {
        throw new Error(t("rain:import-history-error"));
      }
    }
  };
}
